"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormAd = FormAd;
var react_1 = __importStar(require("react"));
var row_ctx_1 = require("../contexts/row_ctx");
var api_1 = require("../api");
var modal_1 = require("../modal");
function FormAd() {
    var _this = this;
    var closeModal = (0, modal_1.useModalClose)();
    var _a = (0, react_1.useContext)(row_ctx_1.RowContext), localRecord = _a.localRecord, updateRecord = _a.updateRecord;
    var results = localRecord.results;
    var handleResultChange = function (value, field) { return __awaiter(_this, void 0, void 0, function () {
        var updatedResults, modifiedResults;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    updatedResults = __assign(__assign({}, results), (_a = {}, _a[field] = value, _a));
                    updateRecord(__assign(__assign({}, localRecord), { results: updatedResults }));
                    if (!(field === "result")) return [3 /*break*/, 2];
                    return [4 /*yield*/, (0, api_1.modifyResultsRemark)(localRecord.order_id, updatedResults)];
                case 1:
                    modifiedResults = _b.sent();
                    updateRecord(__assign(__assign({}, localRecord), { results: modifiedResults }));
                    _b.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var handleSubmit = function (event) {
        event.preventDefault();
        (0, api_1.modifyResults)(localRecord.order_id, results)
            .then(function (updatedData) { return updateRecord(updatedData); })
            .catch(console.error);
        closeModal();
    };
    return (react_1.default.createElement("div", { className: "form-container" },
        react_1.default.createElement("form", { className: "zmsk-form ad-form", onSubmit: handleSubmit },
            react_1.default.createElement("table", null,
                react_1.default.createElement("colgroup", null,
                    react_1.default.createElement("col", { style: { width: "10%" } }),
                    react_1.default.createElement("col", { style: { width: "10%" } }),
                    react_1.default.createElement("col", { style: { width: "10%" } }),
                    react_1.default.createElement("col", { style: { width: "10%" } }),
                    react_1.default.createElement("col", { style: { width: "10%" } }),
                    react_1.default.createElement("col", { style: { width: "15%" } }),
                    react_1.default.createElement("col", { style: { width: "35%" } })),
                react_1.default.createElement("thead", null,
                    react_1.default.createElement("tr", null,
                        react_1.default.createElement("th", null, "\u9776\u70B91"),
                        react_1.default.createElement("th", null, "\u9776\u70B92"),
                        react_1.default.createElement("th", null, "\u9776\u70B93"),
                        react_1.default.createElement("th", null, "\u5185\u53C2"),
                        react_1.default.createElement("th", null, "CRS\u8BC4\u5206"),
                        react_1.default.createElement("th", null, "\u68C0\u6D4B\u7ED3\u679C"),
                        react_1.default.createElement("th", null, "\u68C0\u6D4B\u7ED3\u679C\u63D0\u793A"))),
                react_1.default.createElement("tbody", null,
                    react_1.default.createElement("tr", null,
                        react_1.default.createElement("td", null,
                            react_1.default.createElement("input", { name: "target1", value: results.target1 || "", onChange: function (e) {
                                    return handleResultChange(e.target.value, "target1");
                                } })),
                        react_1.default.createElement("td", null,
                            react_1.default.createElement("input", { name: "target2", value: results.target2 || "", onChange: function (e) {
                                    return handleResultChange(e.target.value, "target2");
                                } })),
                        react_1.default.createElement("td", null,
                            react_1.default.createElement("input", { name: "target3", value: results.target3 || "", onChange: function (e) {
                                    return handleResultChange(e.target.value, "target3");
                                } })),
                        react_1.default.createElement("td", null,
                            react_1.default.createElement("input", { name: "reference", value: results.reference || "", onChange: function (e) {
                                    return handleResultChange(e.target.value, "reference");
                                } })),
                        react_1.default.createElement("td", null,
                            react_1.default.createElement("input", { name: "crs", type: "number", step: "0.01", value: results.crs || "", onChange: function (e) {
                                    return handleResultChange(e.target.value, "crs");
                                } })),
                        react_1.default.createElement("td", null,
                            react_1.default.createElement("select", { name: "result", value: results.result || "", onChange: function (e) {
                                    return handleResultChange(e.target.value, "result");
                                } },
                                react_1.default.createElement("option", { value: "" }),
                                react_1.default.createElement("option", { value: "\u4F4E\u98CE\u9669" }, "\u4F4E\u98CE\u9669"),
                                react_1.default.createElement("option", { value: "\u4E2D\u98CE\u9669" }, "\u4E2D\u98CE\u9669"),
                                react_1.default.createElement("option", { value: "\u9AD8\u98CE\u9669" }, "\u9AD8\u98CE\u9669"),
                                react_1.default.createElement("option", { value: "\u6781\u9AD8\u98CE\u9669" }, "\u6781\u9AD8\u98CE\u9669"))),
                        react_1.default.createElement("td", null,
                            react_1.default.createElement("textarea", { name: "remark", value: results.remark, readOnly: true }))))),
            react_1.default.createElement("div", { className: "foot-button-group" },
                react_1.default.createElement("button", { type: "button", className: "zmsk-button", onClick: closeModal }, "\u53D6\u6D88"),
                react_1.default.createElement("button", { type: "submit", className: "zmsk-button" }, "\u63D0\u4EA4")))));
}
